import React, { FC } from 'react';
import { Grid, Paper } from '@material-ui/core';

import { GroupListFollow, LoaderComponents, Queries, IEmptyState } from 'components';
import { SearchGroupsDocument } from 'api';

interface IProps {
  emptyStateName?: keyof IEmptyState;
  variables: object;
}

const QueryList: FC<IProps> = ({ emptyStateName, variables }) => {
  function renderLoader() {
    const { Content, Image, List, Row } = LoaderComponents;

    return (
      <List rows={6}>
        {rowIndex => (
          <Paper key={rowIndex} style={{ marginBottom: 16 }}>
            <Row spacing={2}>
              <Grid item>
                <Image shape="rounded" height={80} width={80} />
              </Grid>
              <Grid item>
                <Content index={rowIndex} height={40} maxWidth={400} />
              </Grid>
            </Row>
          </Paper>
        )}
      </List>
    );
  }

  return (
    <Queries.Search
      fetchPolicy="network-only"
      loader={renderLoader()}
      document={SearchGroupsDocument}
      variables={variables}>
      {({ loading, exhausted, results, onLoadMore }) => (
        <GroupListFollow
          emptyStateName={emptyStateName}
          loading={loading}
          groups={results}
          disableLoadMore={exhausted}
          onLoadMore={onLoadMore}
        />
      )}
    </Queries.Search>
  );
};

export default QueryList;
